import React from 'react';
import { useTranslation } from '../../i18n/LanguageContext';
import { FileText, Home } from 'lucide-react';

const CGUPage = () => {
  const { t } = useTranslation();

  return (
    <div style={{
      minHeight: '100vh',
      width: '100%',
      background: 'linear-gradient(180deg, #0a0e27 0%, #1a1f3a 100%)',
      color: '#ffffff',
      fontFamily: '-apple-system, BlinkSystemFont, "SF Pro Display", sans-serif',
      padding: '120px 20px 40px',
      maxWidth: '1200px',
      margin: '0 auto'
    }}>
      <button
        onClick={() => window.location.href = '/'}
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          background: 'rgba(255, 255, 255, 0.1)',
          border: '1px solid rgba(255, 255, 255, 0.2)',
          color: '#ffffff',
          padding: '10px 16px',
          borderRadius: '12px',
          fontSize: '14px',
          fontWeight: 600,
          cursor: 'pointer',
          marginBottom: '32px'
        }}
      >
        <Home size={18} />
        Retour à l'accueil
      </button>

      <div style={{
        background: 'rgba(255, 255, 255, 0.05)',
        backdropFilter: 'blur(20px)',
        border: '1px solid rgba(255, 255, 255, 0.1)',
        borderRadius: '20px',
        padding: '40px',
        marginBottom: '32px'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '24px' }}>
          <FileText size={40} color="#00d4ff" />
          <h1 style={{ fontSize: 'clamp(32px, 5vw, 48px)', fontWeight: 800, margin: 0 }}>
            Conditions Générales d'Utilisation
          </h1>
        </div>

        <div style={{ color: 'rgba(255, 255, 255, 0.8)', lineHeight: 1.8, fontSize: '16px' }}>
          <p style={{ marginBottom: '32px', fontSize: '18px', color: 'rgba(255, 255, 255, 0.7)' }}>
            <strong>Dernière mise à jour :</strong> {new Date().toLocaleDateString('fr-FR', { year: 'numeric', month: 'long', day: 'numeric' })}
          </p>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '24px', fontWeight: 700, marginBottom: '16px', color: '#00d4ff' }}>
              1. Objet
            </h2>
            <p style={{ marginBottom: '16px' }}>
              Les présentes Conditions Générales d'Utilisation (ci-après "CGU") ont pour objet de définir les conditions et modalités d'utilisation de la plateforme WorkBiFlow (ci-après "la Plateforme").
            </p>
            <p>
              L'utilisation de la Plateforme implique l'acceptation pleine et entière des présentes CGU. En cas de non-acceptation, l'utilisateur doit s'abstenir d'utiliser la Plateforme.
            </p>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '24px', fontWeight: 700, marginBottom: '16px', color: '#00d4ff' }}>
              2. Accès à la Plateforme
            </h2>
            <p style={{ marginBottom: '16px' }}>
              La Plateforme est accessible gratuitement à tout utilisateur disposant d'un accès internet. Tous les coûts nécessaires à l'accès au service (matériel informatique, connexion internet, etc.) sont à la charge de l'utilisateur.
            </p>
            <p>
              L'accès aux fonctionnalités de la Plateforme est réservé aux utilisateurs ayant créé un compte et souscrit à un abonnement selon les modalités définies dans les offres tarifaires.
            </p>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '24px', fontWeight: 700, marginBottom: '16px', color: '#00d4ff' }}>
              3. Utilisation de la Plateforme
            </h2>
            <p style={{ marginBottom: '16px' }}>
              L'utilisateur s'engage à utiliser la Plateforme conformément à sa destination et de manière conforme aux lois et règlements en vigueur.
            </p>
            <p style={{ marginBottom: '16px' }}>
              L'utilisateur s'interdit notamment de :
            </p>
            <ul style={{ marginLeft: '24px', marginBottom: '16px' }}>
              <li style={{ marginBottom: '8px' }}>Utiliser la Plateforme à des fins illégales ou frauduleuses</li>
              <li style={{ marginBottom: '8px' }}>Perturber le fonctionnement de la Plateforme</li>
              <li style={{ marginBottom: '8px' }}>Tenter d'accéder de manière non autorisée aux systèmes et données</li>
              <li style={{ marginBottom: '8px' }}>Reproduire, copier ou vendre les éléments de la Plateforme</li>
            </ul>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '24px', fontWeight: 700, marginBottom: '16px', color: '#00d4ff' }}>
              4. Données personnelles
            </h2>
            <p style={{ marginBottom: '16px' }}>
              Les données personnelles collectées sur la Plateforme font l'objet d'un traitement conformément à notre Politique de Confidentialité, consultable à l'adresse suivante : <a href="/confidentialite" style={{ color: '#00d4ff', textDecoration: 'underline' }}>/confidentialite</a>
            </p>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '24px', fontWeight: 700, marginBottom: '16px', color: '#00d4ff' }}>
              5. Propriété intellectuelle
            </h2>
            <p style={{ marginBottom: '16px' }}>
              La Plateforme et l'ensemble de son contenu (textes, images, vidéos, logos, etc.) sont la propriété exclusive de WorkBiFlow et sont protégés par les lois relatives à la propriété intellectuelle.
            </p>
            <p>
              Toute reproduction, représentation, modification, publication ou adaptation de tout ou partie des éléments de la Plateforme est interdite sans autorisation écrite préalable de WorkBiFlow.
            </p>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '24px', fontWeight: 700, marginBottom: '16px', color: '#00d4ff' }}>
              6. Responsabilité
            </h2>
            <p style={{ marginBottom: '16px' }}>
              WorkBiFlow s'efforce d'assurer une disponibilité et une qualité optimales de la Plateforme. Cependant, WorkBiFlow ne peut garantir l'absence d'interruptions, d'erreurs ou de bugs.
            </p>
            <p>
              WorkBiFlow ne saurait être tenu responsable des dommages directs ou indirects résultant de l'utilisation ou de l'impossibilité d'utiliser la Plateforme.
            </p>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '24px', fontWeight: 700, marginBottom: '16px', color: '#00d4ff' }}>
              7. Modification des CGU
            </h2>
            <p>
              WorkBiFlow se réserve le droit de modifier les présentes CGU à tout moment. Les modifications prennent effet dès leur publication sur la Plateforme. Il appartient à l'utilisateur de consulter régulièrement les CGU pour prendre connaissance des éventuelles modifications.
            </p>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '24px', fontWeight: 700, marginBottom: '16px', color: '#00d4ff' }}>
              8. Droit applicable et juridiction compétente
            </h2>
            <p style={{ marginBottom: '16px' }}>
              Les présentes CGU sont régies par le droit français.
            </p>
            <p>
              En cas de litige et à défaut d'accord amiable, le litige sera porté devant les tribunaux français conformément aux règles de compétence en vigueur.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default CGUPage;

